/**
 * Crowdex's own glyph (its agent's head, `public/agent-icons/crowdex.svg`) drawn as a template in
 * ink like every app glyph: what the core publishes is shown by it, never by an initial.
 */
export function CrowdexGlyph({ className = 'size-4' }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      className={`shrink-0 ${className}`}
      data-crowdex-glyph
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      viewBox="0 0 24 24"
    >
      <path d="M12 5v4" />
      <circle cx="12" cy="4" fill="currentColor" r="1" stroke="none" />
      <rect height="11" rx="3" width="14" x="5" y="9" />
      <circle cx="9.5" cy="14" fill="currentColor" r="1.2" stroke="none" />
      <circle cx="14.5" cy="14" fill="currentColor" r="1.2" stroke="none" />
      <path d="M10 17.2h4" />
    </svg>
  );
}
